import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const SortSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default SortSVG;
